var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('Sidebar',{staticClass:"slide-in"}),_c('main',[_c('AdminHeader'),_c('div',{staticClass:"p-3"},[_c('transition',{attrs:{"name":"fade-from-bottom","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }